// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { GetPreferredPackageVersionResponse } from '@digitalasset/json-api-ts-client/index';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PackageName } from '../../config/package';
import { useLedgerApiClient } from '../../contexts/LedgerApiContext';
import { useParties } from '../../contexts/PartiesContext';

export const useGetPreferredPackageVersion: (
  packageName: PackageName,
) => UseQueryResult<GetPreferredPackageVersionResponse, string> = (packageName: PackageName) => {
  const ledgerApi = useLedgerApiClient();
  const { operator } = useParties();
  return useQuery({
    queryKey: ['queryPreferredPackageVersion', ledgerApi, operator, packageName],
    queryFn: async () => {
      return ledgerApi.getPreferredPackageVersion(packageName, operator);
    },
    refetchInterval: false,
  });
};
